// Manus Frequency Fone Fixes — loaded as a separate asset to bypass page cache
(function() {
  'use strict';

  var VARIANT_IDS = {
    'Digital Download': '42887377190989',
    'Frequency Fone Device': '42887377518669',
    'Frequency Fone': '42887377518669'
  };

  var DIGITAL_IMG = 'https://cdn.shopify.com/s/files/1/0701/0480/9549/files/Digital_Download.png?v=1776709477';
  var DEVICE_IMG = 'https://cdn.shopify.com/s/files/1/0701/0480/9549/files/Smartphoneandplantonsleekcountertop.png?v=1776035723';

  function applyFixes() {
    if (window._manusFixes) return;
    window._manusFixes = true;

    var isHomepage = window.location.pathname === '/' || window.location.pathname === '';

    // ─── 1. Live inventory check ─────────────────────────────────────────────
    if (isHomepage && !window._manusInventoryChecked) {
      window._manusInventoryChecked = true;
      fetch('/products/frequency-fone.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          product.variants.forEach(function(v) {
            document.querySelectorAll('.variant-pill').forEach(function(pill) {
              var nameEl = pill.querySelector('.pill-name');
              var pillText = nameEl ? nameEl.textContent.trim() : pill.textContent.replace('Sold Out','').trim();
              var isMatch = pillText === v.title ||
                (v.title === 'Frequency Fone' && pillText === 'Frequency Fone Device');
              if (!isMatch) return;
              if (v.available) {
                pill.classList.remove('sold-out');
                pill.dataset.soldOut = 'false';
                pill.style.pointerEvents = '';
                var soLabel = pill.querySelector('.pill-sold-out');
                if (soLabel) soLabel.remove();
              } else {
                pill.classList.add('sold-out');
                pill.dataset.soldOut = 'true';
                pill.style.pointerEvents = 'none';
                if (!pill.querySelector('.pill-sold-out')) {
                  var soSpan = document.createElement('span');
                  soSpan.className = 'pill-sold-out';
                  soSpan.textContent = 'Sold Out';
                  pill.appendChild(soSpan);
                }
                // If this sold-out pill was active, switch to first available
                if (pill.classList.contains('active')) {
                  pill.classList.remove('active');
                  var firstAvail = document.querySelector('.variant-pill:not(.sold-out)');
                  if (firstAvail) {
                    firstAvail.classList.add('active');
                    var priceMain = document.querySelector('.price-main');
                    var priceNote = document.querySelector('.price-note');
                    var nameEl2 = firstAvail.querySelector('.pill-name');
                    var availName = nameEl2 ? nameEl2.textContent.trim() : '';
                    var prices = {
                      'Digital Download': ['$39.95', 'CAD \u2014 Instant Access'],
                      'Frequency Fone Device': ['$399.95', 'CAD \u2014 Physical Device']
                    };
                    if (prices[availName] && priceMain) {
                      priceMain.textContent = prices[availName][0];
                      priceNote.textContent = prices[availName][1];
                    }
                  }
                }
              }
            });
          });
        })
        .catch(function() {});
    }

    // ─── 2. Add data-variant-id to pills ─────────────────────────────────────
    if (isHomepage) {
      document.querySelectorAll('.variant-pill').forEach(function(pill) {
        var nameEl = pill.querySelector('.pill-name');
        var name = nameEl ? nameEl.textContent.trim() : '';
        if (VARIANT_IDS[name] && !pill.getAttribute('data-variant-id')) {
          pill.setAttribute('data-variant-id', VARIANT_IDS[name]);
        }
      });
    }

    // ─── 3. Fix hero image swap on pill click ─────────────────────────────────
    if (isHomepage) {
      var heroImg = document.querySelector('.hero-product-img img');
      var variantPills = document.querySelectorAll('.hero-variants .variant-pill, .variant-pill');
      if (heroImg && !heroImg.getAttribute('data-manus-img-fixed')) {
        heroImg.setAttribute('data-manus-img-fixed', 'true');
        // Set initial image based on active pill
        var activePill = document.querySelector('.variant-pill.active');
        if (activePill) {
          var activeNameEl = activePill.querySelector('.pill-name');
          var activeName = activeNameEl ? activeNameEl.textContent.trim() : '';
          heroImg.src = activeName.indexOf('Digital') >= 0 ? DIGITAL_IMG : DEVICE_IMG;
        } else {
          heroImg.src = DIGITAL_IMG;
        }
      }
      variantPills.forEach(function(pill) {
        if (!pill.getAttribute('data-manus-img-listener')) {
          pill.setAttribute('data-manus-img-listener', 'true');
          pill.addEventListener('click', function() {
            if (pill.classList.contains('sold-out') || pill.dataset.soldOut === 'true') return;
            var img = document.querySelector('.hero-product-img img');
            if (!img) return;
            var pillNameEl = pill.querySelector('.pill-name');
            var name = pillNameEl ? pillNameEl.textContent.trim() : '';
            img.src = name.indexOf('Digital') >= 0 ? DIGITAL_IMG : DEVICE_IMG;
            img.alt = name;
          });
        }
      });
    }

    // ─── 4. Fix Order Now / Buy button — correct variant to cart ─────────────
    if (isHomepage) {
      var btn = document.querySelector('.hero-add-btn');
      if (btn && !btn.getAttribute('data-manus-cart-fixed')) {
        // Clone to remove any stale listeners from the section JS
        var newBtn = btn.cloneNode(true);
        newBtn.setAttribute('data-manus-cart-fixed', 'true');
        btn.parentNode.replaceChild(newBtn, btn);
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var activePill = document.querySelector('.variant-pill.active');
          var variantId = null;
          if (activePill) {
            variantId = activePill.getAttribute('data-variant-id');
            if (!variantId) {
              var nameEl = activePill.querySelector('.pill-name');
              var pillName = nameEl ? nameEl.textContent.trim() : '';
              variantId = VARIANT_IDS[pillName] || null;
            }
          }
          if (!variantId) variantId = '42887377190989'; // fallback: Digital Download
          newBtn.disabled = true;
          newBtn.textContent = 'Processing...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: parseInt(variantId), quantity: 1})
          }).then(function() {
            window.location.href = '/checkout';
          }).catch(function() {
            window.location.href = '/pages/order';
          });
        });
      }
    }
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }
  // Also run after a short delay to catch dynamically loaded content
  setTimeout(applyFixes, 600);
  setTimeout(applyFixes, 1500);
})();
